import { useLanguage } from "@src/context/LanguageContext";
import DynamicFormFieldId from "./DynamicFormFieldId";
import { CREATE_PAGE_INDEX } from "@src/config/id/constant";


const Create = (props: any) => {

    const {setLoading,isEdit,setAddonState,requestData,setRequestData, insuranceValues, setInsuranceValues} =props 
    const {translations} = useLanguage();
    
    return (
        <div className="create-application-outer">
            <h3>{translations?.CREATE_APP?.APPLICATION_DETAILS}</h3>

            <div className="create-application-filed">
                <div className="row">
                   <DynamicFormFieldId
                        fields={props?.sectionItem?.[CREATE_PAGE_INDEX.CREATE]?.blocks?.[0]?.fields}
                        setLoading={setLoading}
                        setSectionItem={props.setSectionItem}
                        sectionItem={props?.sectionItem}
                        sectionIndex ={CREATE_PAGE_INDEX.CREATE}
                        isEdit={isEdit}
                        key={CREATE_PAGE_INDEX.CREATE}
                        setAddonState={setAddonState}
                        requestData={requestData}
                        setRequestData={setRequestData}
                        insuranceValues = {insuranceValues}
                        setInsuranceValues = {setInsuranceValues}
                    />
                </div>

                <div className="btn-continue btn-bottom-fixed">
                    <button className="btn-primary" onClick={()=>props.handleSubmit(CREATE_PAGE_INDEX.CREATE)}>{props?.sectionItem?.[CREATE_PAGE_INDEX.CREATE]?.btn?.title}</button>
                    </div>
            </div>
        </div>
    )

}
export default Create




